// Tier helpers. Reads the active workspace's tier from JWT claims
// (populated by the bridge from the server's workspace billing endpoint).
//
// The intranet itself is NOT tier-gated — it's an org-level feature.
// Anyone in a team org gets every collab surface. Monetization happens
// via server-side credit metering (PRICING.md), not access gates.
//
// These helpers remain for a narrow set of admin-power surfaces
// (`admin-permissions`, `admin-logs`) that stay Scale-only because they
// exist for multi-org tenants with dedicated admin staff — not because
// we want to upsell core collab.
//
// Tier order: free < pro < scale < enterprise. Each tier "includes" all
// tiers below it.

const TIER_ORDER = { free: 0, pro: 1, scale: 2, enterprise: 3 }

const _normalize = (raw) => {
  if (!raw) return 'free'
  const s = typeof raw === 'string' ? raw : (raw.tier || raw.plan || raw.name || '')
  return String(s).toLowerCase().trim() || 'free'
}

export const workspaceTier = (root) =>
  _normalize(root?.jwtClaims?.workspace_tier)

export const hasTier = (root, minTier) => {
  const cur = TIER_ORDER[workspaceTier(root)] ?? 0
  const min = TIER_ORDER[_normalize(minTier)] ?? 0
  return cur >= min
}

export const isPro = (root) => hasTier(root, 'pro')
export const isScale = (root) => hasTier(root, 'scale')
export const isEnterprise = (root) => hasTier(root, 'enterprise')

export const tierLabel = (tier) => {
  const t = _normalize(tier)
  return t.charAt(0).toUpperCase() + t.slice(1)
}
